import React, { useState } from 'react';
export default function WeatherSearch({ onSearch }) {
  const [q, setQ] = useState('');
  return (
    <form onSubmit={(e)=>{ e.preventDefault(); if(q.trim()) onSearch(q.trim()); }}>
      <input placeholder="Enter city (e.g., London)" value={q} onChange={e=>setQ(e.target.value)} />
      <button type="submit">Search</button>
    </form>
  );
}
